import Schedule from "./Schedule";

export const columns = [
  {
    field: "building_address",
    headerName: "Building",
    renderCell: (params) => {
      return <p className="">{params.value}</p>;
    },
    minWidth: 110,
    flex: 1.5,
    // editable: true,
  },

  {
    field: "apartment",
    headerName: "Unit",
    renderCell: (params) => {
      return <p className="unit-ticket">{params.value}</p>;
    },
    minWidth: 100,
    flex: 0.7,
    // editable: true,
    sortable: false,
  },

  {
    field: "service_type",
    headerName: "Type",
    renderCell: (params) => {
      return <p>{params.value}</p>;
    },
    minWidth: 130,
    flex: 1,
    // editable: true,
    sortable: false,
  },
  {
    field: "Action",
    headerName: "Action",
    renderCell: (params) => {
      return <Schedule params={params} />;
    },
    minWidth: 130,
    flex: 1,
    // editable: true,
    sortable: false,
  },
];
